import { yupResolver } from '@hookform/resolvers/yup';
import { Resolver } from 'react-hook-form';
import { CreateUserT, OneUserT, UpdateUserT } from 'shared/api/types/users';
import * as Yup from 'yup';
import initDefaultSchema from '../yupConfig';

initDefaultSchema();

// Create User
export type CreateUserFormT = CreateUserT['request'];
export const getCreateUserValues = (): CreateUserFormT => ({
  email: '',
  name: '',
  surname: '',
  role: '',
  password: '',
  resources: [],
});
const createUserSchema: Yup.ObjectSchema<CreateUserFormT> = Yup.object({
  email: Yup.string().required(),
  name: Yup.string().required(),
  surname: Yup.string().required(),
  role: Yup.string().required(),
  password: Yup.string().required(),
  resources: Yup.array().of(Yup.object({ resourceId: Yup.string(), resourceType: Yup.string() })) as FixMeLater,
});
export const createUserResolver = yupResolver(createUserSchema) as Resolver<CreateUserFormT>;

// Update User
export type UpdateUserFormT = UpdateUserT['request'];
export const getUpdateUserValues = (values?: OneUserT['response']): UpdateUserFormT => {
  return {
    email: values?.email,
    name: values?.name,
    surname: values?.surname,
    role: values?.role,
    password: values?.password,
    resources: values?.resources?.map((r) => ({ resourceId: r.resource.id, resourceType: r.resource.type })) ?? [],
  }
};
const updateUserSchema: Yup.ObjectSchema<UpdateUserFormT> = Yup.object({
  // type: Yup.string().oneOf(userTypes).required(),
  email: Yup.string().required(),
  name: Yup.string().required(),
  surname: Yup.string().required(),
  role: Yup.string().required(),
  password: Yup.string(),
  resources: Yup.array().of(Yup.object({ resourceId: Yup.string(), resourceType: Yup.string() })) as FixMeLater,
});
export const updateUserResolver = yupResolver(updateUserSchema) as Resolver<UpdateUserFormT>;
